import { Image, Pressable, View, Text } from 'react-native'
import ModalWrapper from '../../components/modal/ModalWrapper'
import useDimension from '../../hooks/use-dimension'
import { imgHints } from '../../data/images'

const { bgModal, btnYes, btnNo } = imgHints

type Props = {
  isOpen: boolean
  onYes: () => void
  onCancel: () => void
}

function MusicModal({ isOpen, onYes, onCancel }: Props) {
  const { ws } = useDimension()

  if (!isOpen) return null

  return (
    <ModalWrapper
      isOpen={isOpen}
      onClose={onCancel}
      bgImg={bgModal ?? ''}
      styleProps={{ modalTp: 228.5, bgW: 326.5, bgH: 143 }}
      BgColor={'#fff6'}
    >
      <Text
        style={{
          marginTop: 42 * ws,
          fontFamily: 'love',
          fontSize: 16.5 * ws,
          fontWeight: '600',
          lineHeight: 31.5,
          letterSpacing: 1 * ws,
          color: 'rgb(215,93,150)',
        }}
      >
        遊戲即將開始，是否要開啟聲音呢？
      </Text>
      <View style={{ flexDirection: 'row', marginTop: 25.5 * ws }}>
        <Pressable
          style={({ pressed }) => [
            { opacity: pressed ? 0.5 : 1.0, marginRight: 10 * ws },
          ]}
          onPress={onYes}
        >
          <Image
            source={{ uri: btnYes }}
            style={{
              width: 65 * ws,
              height: 40 * ws,
            }}
            resizeMode="contain"
            aria-label={`btn-yes`}
          />
        </Pressable>
        <Pressable
          style={({ pressed }) => [{ opacity: pressed ? 0.5 : 1.0 }]}
          onPress={onCancel}
        >
          <Image
            source={{ uri: btnNo }}
            style={{
              width: 65 * ws,
              height: 40 * ws,
            }}
            resizeMode="contain"
            aria-label={`btn-no`}
          />
        </Pressable>
      </View>
    </ModalWrapper>
  )
}

export default MusicModal
